














































































































































































































































import { Component, Vue, Ref } from 'vue-property-decorator'
import TableComponent from '@/components/TableComponent'
import AddOrgModal from './components/AddOrgModal.vue'
import AddPositionModal from './components/AddPositionModal.vue'
import AddUser from './components/AddUser.vue'
import MainHeader from '@/components/MainHeader'
import {
  getRoleList,
  getOrganizationTree,
  getPositionTree,
  deleteOrganization,
  deletePosition,
  getOrgRole,
} from '@/api/system'

@Component({
  components: {
    TableComponent,
    AddOrgModal,
    AddPositionModal,
    AddUser,
    MainHeader
  },
})
export default class OrganizationManage extends Vue {
  private orgVisible: boolean = false;

  private positionVisible: boolean = false;

  private userVisible: boolean = false;

  private expandedKeys: any = [];

  private expandedPostKeys: any = [];

  private activeKey: number = 1;

  @Ref('table') readonly table!: TableComponent;

  // 机构树
  private gData: any = [];

  // 组织树
  private postData: any = [];

  // 机构树查询区
  private searchValue: any = '';

  private autoExpandParent: boolean = false;

  private autoPostExpandParent: boolean = false;

  // 查询区高亮用
  private dataList: any = [];

  // 机构树右键
  private NodeTreeItem: any = null; // 右键菜单

  // 机构树左键
  private SelectTreeItem: any = null;

  // 职位树左键
  private SelectPostTreeItem: any = null;

  // 区分新增修改
  private status: number = 1;

  private editId: string = '';

  // 机构树增删改样式
  private tmpStyle: any = '';

  // 职位树增删改样式
  private tmpPostStyle: any = '';

  // 职位树查询区
  private searchPostValue: any = '';

  // 职位树右键
  private NodePostTreeItem: any = null; // 右键菜单

  // 查询区高亮用
  private dataPostList: any = [];

  private deleteBatch: string = '/front/energygov/v1/supervisionUserInfo/';

  private columns: any[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 60,
      customRender: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '用户名',
      dataIndex: 'userName',
      key: 'userName',
      width: '10%',
      ellipsis: true,
    },
    {
      title: '姓名',
      dataIndex: 'realName',
      key: 'realName',
      width: '10%',
    },
    {
      title: '所属组织',
      dataIndex: 'orgName',
      width: '20%',
      ellipsis: true,
      key: 'orgName',
    },
    {
      title: '所属职位',
      dataIndex: 'positionName',
      key: 'positionName',
      width: '20%',
      ellipsis: true,
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      width: '15%',
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: '10%',
      scopedSlots: { customRender: 'action' },
    },
  ];

  private orgRoleList: any = [];

  

  private dataPost = {
    orgId: '',
    positionId: '',

  };
  private getList= getRoleList
  private callback(val: number) {
    this.activeKey = val
    if (Number(val) === 1) {
      this.dataPost.positionId = ''
    } else {
      this.dataPost.orgId = ''
    }
  }

  private closeModal1(val: any) {
    this.getOrgTree()
    this.NodeTreeItem = null
    if (val === 2) {
      (this.table as any).getData()
    }
  }

  // 分页请求参数 这里可以做一些请求参数的自定义
  private setParams() {
    const data = { ...this.dataPost }
    return data
  }

  public returnBack() {
    this.$router.back()
  }

  private getOrgRole() {
    // getOrgRole().then((res: any) => {
    //   if (res && res.status === 0) {
    //     this.orgRoleList = res.data
    //   }
    // })
  }

  // 获取组织树

  private getOrgTree() {
    getOrganizationTree().then((res: any) => {
      if (res && res.status === 0) {
        this.gData = [res.data]
        this.$nextTick(()=>{
          this.gData = this.soltData(this.gData)
        })
        
        this.generateList(this.gData)
      }
    })
  }

  private soltData(data: any[]) {
    const arr: any = data
    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach((item: any) => {
        item.scopedSlots = { title: 'orgName' }
        if (item.children) {
          this.soltData(item.children)
        }
      })
    }
    return arr
  }

  // 获取职位树

  private getPoiTree() {
    getPositionTree().then((res: any) => {
      if (res && res.status === 0) {
        this.postData = this.formatData([res.data])
        this.generatePostList(this.postData)
      }
    })
  }

  private formatData(list: any[]) {
    const arr: any = []
    let obj = {}
    if (Array.isArray(list) && list.length > 0) {
      list.forEach((item) => {
        if (item.children) {
          item.scopedSlots = { title: 'title' }
          item.children = this.formatData(item.children)
        }
        obj = {
          key: item.id,
          title: item.positionName,
          children: item.children,
          scopedSlots: {title: 'title'},
          parentId: item.parentId,
        }
        arr.push(obj)
      })
    }
    return arr
  }

  // 处理组织树
  public generateList(data: any): void {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const key = node.id
      this.dataList.push({
        key,
        title: node.orgName,
        scopedSlots: { title: 'title' },
      })
      if (node.children) {
        this.generateList(node.children)
      }
    }
  }

  // 处理职位树
  public generatePostList(data: any): void {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const key = node.key
      this.dataPostList.push({ key, title: node.title })
      if (node.children) {
        this.generatePostList(node.children)
      }
    }
  }

  public created() {
    this.getOrgTree()
    this.getPoiTree()
    // this.getOrgRole()
  }

  // 处理组织树
  public getParentKey(key: any, tree: any): void {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item: any) => item.id === key)) {
          parentKey = node.id
        } else if (this.getParentKey(key, node.children) !== undefined) {
          parentKey = this.getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  // 处理职位树
  public getPostParentKey(key: any, tree: any): void {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item: any) => item.key === key)) {
          parentKey = node.key
        } else if (this.getPostParentKey(key, node.children) !== undefined) {
          parentKey = this.getPostParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  // 处理组织树
  public onExpand(expandedKeys: any): void {
    this.expandedKeys = expandedKeys
    this.autoExpandParent = false
  }

  // 处理职位树
  public onPostExpand(expandedKeys: any): void {
    this.expandedPostKeys = expandedKeys
    this.autoPostExpandParent = false
  }

  // 组织树查询区
  public onChange(e: any): void {
    const value = e.target.value
    const expandedKeys = this.dataList
      .map((item: any) => {
        if (item.title.indexOf(value) > -1) {
          return this.getParentKey(item.key, this.gData)
        }
        return null
      })
      .filter(
        (item: any, i: any, self: any) => item && self.indexOf(item) === i
      )
    Object.assign(this, {
      expandedKeys,
      searchValue: value,
      autoExpandParent: true,
    })
  }

  // 职位树查询区
  public onPostChange(e: any) {
    const value = e.target.value
    const expandedPostKeys = this.dataPostList
      .map((item: any) => {
        if (item.title.indexOf(value) > -1) {
          return this.getPostParentKey(item.key, this.postData)
        }
        return null
      })
      .filter(
        (item: any, i: any, self: any) => item && self.indexOf(item) === i
      )
    Object.assign(this, {
      expandedPostKeys,
      searchPostValue: value,
      autoPostExpandParent: true,
    })
  }

  private handleDelete(record: any) {
    (this.table as any).deleteRecrod(record.id)
  }

  // 组织树右键点击
  public onRightClick({ event, node }: any): void {
    const x = event.currentTarget.offsetLeft + event.currentTarget.clientWidth
    const y = event.currentTarget.offsetTop
    this.NodeTreeItem = {
      pageX: x,
      pageY: y,
      id: node._props.eventKey,
      title: node._props.dataRef.orgName,
      parentId: node._props.dataRef.parentId || null,
    }
    this.tmpStyle = {
      position: 'absolute',
      maxHeight: 40,
      textAlign: 'center',
      left: `${x + 9 - 0}px`,
      top: `${y + 2 - 0}px`,
      display: 'flex',
      flexDirection: 'row',
    }
  }

  // 职位树右键点击
  public onRightPostClick({ event, node }: any): void {
    const x = event.currentTarget.offsetLeft + event.currentTarget.clientWidth
    const y = event.currentTarget.offsetTop
    this.NodePostTreeItem = {
      pageX: x,
      pageY: y,
      id: node._props.eventKey,
      title: node._props.dataRef.title,
      parentId: node._props.dataRef.parentId || null,
    }
    this.tmpPostStyle = {
      position: 'absolute',
      maxHeight: 40,
      textAlign: 'center',
      left: `${x + 9 - 0}px`,
      top: `${y + 2 - 0}px`,
      display: 'flex',
      flexDirection: 'row',
    }
  }
  //   private handleDelete(record: any) {
  //   (this.table as any).deleteRecrod(record.id)
  // }

  // 用于点击隐藏增删改菜单
  public clearMenu(selectedKeys: any): void {
    this.closeModal1(0)
    // this.NodeTreeItem = null
    // this.SelectPostTreeItem = ''
    this.SelectTreeItem = selectedKeys[0]
    this.dataPost.orgId = selectedKeys[0];
    (this.table as any).getData()
  }

  // 用于组织树点击隐藏增删改菜单
  public clearPostMenu(selectedKeys: any): void {
      this.closeModal2(0)
    // this.NodePostTreeItem = null
    // this.SelectTreeItem = ''
    this.SelectPostTreeItem = selectedKeys[0]
    this.dataPost.positionId = selectedKeys[0];
    (this.table as any).getData()
  }

  public closeModal2(val: any): void {
    this.positionVisible = val
    this.getPoiTree()
    this.NodePostTreeItem = null
  }
  public closeModal3(val: any): void {
    (this.table as any).refresh(true)
  }

  // 添加下一级组织
  public orgAdd() {
    this.orgVisible = true
    this.status = 1
  }

  public orgEdit() {
    this.status = 2
    this.orgVisible = true
  }

  public orgDelete() {
    const me = this
    this.$confirm({
      title: '删除提示',
      content: '确定要删除选中的组织？',
      cancelText: '取消',
      okText: '确认',
      icon: 'exclamation-circle',
      onOk() {
        const id = me.NodeTreeItem.id
        deleteOrganization(id).then((res: any) => {
          if (res.status === 0) {
            me.$message.success('已删除！')
            me.closeModal1(1)
            me.getOrgTree()
          } else {
            me.$message.warning(res.message)
          }
        })
      },
    })
  }

  // 添加下一级职位
  public postAdd() {
    this.positionVisible = true
    this.status = 1
  }

  public postEdit() {
    this.positionVisible = true
    this.status = 2
  }

  public postDelete() {
    const me = this
    this.$confirm({
      title: '删除提示',
      content: '确定要删除选中的职位？',
      icon: 'exclamation-circle',
      cancelText: '取消',
      okText: '确认',
      onOk() {
        const id = me.NodePostTreeItem.id
        deletePosition(id).then((res: any) => {
          if (res.status === 0) {
            me.$message.success('已删除！')
            me.closeModal2(0)
            me.getPoiTree()
          } else {
            me.$message.warning(res.message)
          }
        })
      },
    })
  }

  // 添加职位
  public handleAddPosition(): void {
    if (this.SelectTreeItem !== null) {
      this.positionVisible = true
      this.status = 1
      this.NodePostTreeItem = null
    } else {
      this.$message.error('请选择组织机构！')
    }
  }

  // 创建用户
  public handleAddUser(): void {
    this.editId = ''
    // if (Number(this.activeKey) === 1 && !this.SelectTreeItem) {
    //   this.$message.error('请选择组织机构！')
    //   return
    // }
    // if (Number(this.activeKey) === 2 && !this.SelectPostTreeItem) {
    //   this.$message.error('请选择职位！')
    //   return
    // }
    this.userVisible = true
    this.status = 1
  }

  public handleEdit(val: any): void {
    this.status = 2
    this.editId = val.id
    this.userVisible = true
  }
}
